function getRotationAngle(i, degreesPerWedge) {
    return i * degreesPerWedge + -degreesPerWedge / 2;
}

const circleAnimClass = "circle-anim-forward";
const circleAnimReverseClass = "circle-anim-reverse";
function pulseCircles() {
    const reverseAnims = document.querySelectorAll("." + circleAnimReverseClass);
    reverseAnims.forEach(reverseAnim => {
        if (reverseAnim && typeof reverseAnim.beginElement === 'function') {
            const parentCircle = reverseAnim.parentElement;
            const forwardAnim = parentCircle ? parentCircle.querySelector("." + circleAnimClass) : null;
            if (forwardAnim) {
                reverseAnim.addEventListener('endEvent', function onReverseEnd() {
                    forwardAnim.beginElement();
                    reverseAnim.removeEventListener('endEvent', onReverseEnd);
                });
            }
            reverseAnim.beginElement();
        }
    });
}

function calcWedgeGap(wedgeCount) {
    if (wedgeCount <= 6) {
        return 18;
    }
    return 12;
}

function renderWheel(wheelSvg) {
    const wheelTransformWrapper = document.getElementById("wheel-transform-wrapper");
    if (!wheelSvg || !wheelTransformWrapper || 'configured' in wheelSvg.dataset)
        return () => { };

    wheelSvg.dataset.configured = true;

    const diagramWheelSize = wheelSvg.viewBox.baseVal.height;
    const wheelData = wheelSvg.querySelectorAll("#wheel-transform-wrapper > g");

    wheelSvg.setAttribute("viewBox", `0 0 ${diagramWheelSize / 2} ${diagramWheelSize}`);
    const totalWedges = wheelData.length;
    const degreesPerWedge = 360 / totalWedges;

    const cx = 0, cy = diagramWheelSize / 2;
    const outerRadius = diagramWheelSize / 2 * 0.95;
    const innerRadius = diagramWheelSize / 2 * 0.2;
    const gapWidthPixels = calcWedgeGap(totalWedges);

    const masterPathString = createUniformWedgePath(cx, cy, outerRadius, innerRadius, 0, degreesPerWedge, gapWidthPixels);

    const easeOutCubic = (x) => 1 - Math.pow(1 - x, 3);
    const lerp = (min, max, x) => min + (max - min) * x;
    const makeCircleAnimValues = (min, max, valueCount, timingFunc) => {
        const vals = [min];
        for (let i = 1; i <= valueCount; i++) {
            vals.push(Math.floor(lerp(min, max, timingFunc(i / (valueCount - 1)))));
        }
        return vals.join(";");
    };

    const circleHolder = wheelSvg.getElementById("circle-holder");
    if (circleHolder) {
        const makeCirc = (r, c) => {
            const circ = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            circ.setAttribute("r", r);
            circ.setAttribute("cx", 0);
            circ.setAttribute("cy", diagramWheelSize / 2);
            circ.style.fill = c;
            circ.innerHTML = `
                <animate class="${circleAnimClass}" fill="freeze" attributeName="r" begin="0s" dur="0.7s" repeatCount="1" values="${makeCircleAnimValues(r / 2, r, 10, easeOutCubic)}"/>
                <animate class="${circleAnimClass} ${circleAnimReverseClass}" fill="freeze" attributeName="r" begin="indefinite" dur="0.5s" repeatCount="1" values="${makeCircleAnimValues(r, r / 2, 10, easeOutCubic)}"/>
            `;
            circleHolder.appendChild(circ);
        };

        const minRad = 0.1, maxRad = 1.05;
        const maxSat = 90, minSat = 10;
        const circles = 15;
        for (let i = circles; i >= 0; i--) {
            const rad = lerp(minRad, maxRad, i / circles);
            makeCirc(outerRadius * rad, `color-mix(in oklab, var(--brightBlue), var(--white) ${lerp(minSat, maxSat, i / circles)}%)`);
        }
    }

    setupObserver(wheelSvg, pulseCircles);

    wheelData.forEach((pathGroup, i) => {
        const rotationAngle = getRotationAngle(i, degreesPerWedge);

        pathGroup.setAttribute("transform", `rotate(${rotationAngle}, ${cx}, ${cy})`);

        const pathElement = document.createElementNS("http://www.w3.org/2000/svg", "path");
        pathElement.setAttribute("class", "wheel-wedge");
        pathElement.setAttribute("data-goal", pathGroup.dataset.goal);
        pathElement.setAttribute("data-index", i);
        pathElement.setAttribute("d", masterPathString);

        pathGroup.appendChild(pathElement);

        let midAngleDeg = (rotationAngle + (degreesPerWedge / 2)) % 360;
        if (midAngleDeg < 0) midAngleDeg += 360;

        const midAngleRad = midAngleDeg * (Math.PI / 180);
        const textRadius = innerRadius + (outerRadius - innerRadius) * 0.9;
        const textX = cx + textRadius * Math.cos(midAngleRad);
        const textY = cy + textRadius * Math.sin(midAngleRad);

        let textRotation = midAngleDeg;
        let textAnchor = "end";

        const textGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
        textGroup.setAttribute("class", "wedge-text-group");
        textGroup.setAttribute("transform", `rotate(${textRotation}, ${textX}, ${textY})`);
        textGroup.innerHTML = `
            <text x="${textX}" y="${textY - 10}" text-anchor="${textAnchor}" class="wedge-number">${pathGroup.dataset.goal}</text>
            <text x="${textX}" y="${textY + 12}" text-anchor="${textAnchor}" class="wedge-label">${pathGroup.dataset.label}</text>
        `;

        wheelTransformWrapper.appendChild(textGroup);
    });


    return (rotation) => {
        wheelTransformWrapper.style.transform = `rotate(${rotation}deg)`;
    };
}

function setupObserver(target, cb) {
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.2
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                cb();
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    if (target) {
        observer.observe(target);
    }
}

function initWheel() {
    const wheelSvg = document.getElementById('wheelSvg');
    const transformCallback = renderWheel(wheelSvg);

    const wedges = Array.from(document.querySelectorAll('.wheel-wedge'));
    const initiatives = Array.from(document.querySelectorAll('.initiative'));
    const descriptions = Array.from(document.querySelectorAll('.strategy-description'));

    const degreesPerWedge = 360 / wedges.length;

    let currentWheelRotation = 0;
    function selectGoalByWedgeIndex(selectedIndex) {
        const selectedWedge = wedges[selectedIndex];
        const targetGoalCode = selectedWedge.getAttribute('data-goal');

        const evenWedges = (wedges.length / 2) % 2 === 0;
        const targetAngle = -getRotationAngle(selectedIndex, degreesPerWedge) - (evenWedges ? degreesPerWedge : (degreesPerWedge / 2));
        const currentNormalized = (currentWheelRotation % 360 + 360) % 360;
        const targetNormalized = (targetAngle % 360 + 360) % 360;

        let angleDifference = targetNormalized - currentNormalized;
        if (angleDifference > 180) {
            angleDifference -= 360;
        } else if (angleDifference < -180) {
            angleDifference += 360;
        }
        currentWheelRotation += angleDifference;

        transformCallback(currentWheelRotation);

        wedges.forEach(w => {
            w.classList.toggle('active', w.getAttribute('data-goal') === targetGoalCode);
        });

        descriptions.forEach(desc => {
            desc.classList.toggle('active', desc.id === `desc-${targetGoalCode}`);
        });

        initiatives.forEach(init => {
            if (init.getAttribute('data-parent') === targetGoalCode) {
                init.classList.remove('inactive');
                init.classList.add('active');
            } else {
                init.classList.remove('active');
                init.classList.add('inactive');
            }
        });

        pulseCircles();
    }

    wedges.forEach(wedge => {
        wedge.addEventListener('click', () => {
            const index = parseInt(wedge.getAttribute('data-index'));
            selectGoalByWedgeIndex(index);
        });
    });

    selectGoalByWedgeIndex(0);
}

/**
 * Generates an SVG path string for a circle wedge with uniform pixel-width gaps.
 * @param {number} cx - Center X coordinate
 * @param {number} cy - Center Y coordinate
 * @param {number} rOuter - Outer radius
 * @param {number} rInner - Inner radius
 * @param {number} startAngleDeg - Starting angle of the total slice block (degrees)
 * @param {number} endAngleDeg - Ending angle of the total slice block (degrees)
 * @param {number} gapWidthPx - The desired uniform gap width in pixels (e.g., 8)
 * @returns {string} The precise SVG path data string
 */
function createUniformWedgePath(cx, cy, rOuter, rInner, startAngleDeg, endAngleDeg, gapWidthPx) {
    const rToD = 180 / Math.PI;
    const dToR = Math.PI / 180;

    // Calculate the midpoint angle of the wedge block
    const midAngleDeg = startAngleDeg + (endAngleDeg - startAngleDeg) / 2;

    // Half of the total pixel gap width applied to each side of the wedge
    const halfGap = gapWidthPx / 2;

    // Calculate the precise angular offset required at the outer radius
    // We use Math.asin to solve for the angle given the opposite side (halfGap) and hypotenuse (radius)
    const outerOffsetDeg = Math.asin(halfGap / rOuter) * rToD;

    // Calculate the precise angular offset required at the inner radius
    // Because rInner is smaller, innerOffsetDeg will naturally be a larger angle
    const innerOffsetDeg = Math.asin(halfGap / rInner) * rToD;

    // Apply the custom, variable angle offsets to the start and end positions
    const outerStartAngle = (startAngleDeg + outerOffsetDeg) * dToR;
    const outerEndAngle = (endAngleDeg - outerOffsetDeg) * dToR;
    const innerStartAngle = (startAngleDeg + innerOffsetDeg) * dToR;
    const innerEndAngle = (endAngleDeg - innerOffsetDeg) * dToR;

    // Map out the four exact corner coordinates
    const xOuterStart = cx + rOuter * Math.cos(outerStartAngle);
    const yOuterStart = cy + rOuter * Math.sin(outerStartAngle);
    const xOuterEnd = cx + rOuter * Math.cos(outerEndAngle);
    const yOuterEnd = cy + rOuter * Math.sin(outerEndAngle);

    const xInnerEnd = cx + rInner * Math.cos(innerEndAngle);
    const yInnerEnd = cy + rInner * Math.sin(innerEndAngle);
    const xInnerStart = cx + rInner * Math.cos(innerStartAngle);
    const yInnerStart = cy + rInner * Math.sin(innerStartAngle);

    // Flag logic checks if the calculated arc spans past a half-circle
    const largeArcFlag = (endAngleDeg - startAngleDeg) <= 180 ? 0 : 1;

    // Compile the uniform SVG path
    let pathData = `M ${xOuterStart},${yOuterStart} `;
    pathData += `A ${rOuter},${rOuter} 0 ${largeArcFlag},1 ${xOuterEnd},${yOuterEnd} `;
    pathData += `L ${xInnerEnd},${yInnerEnd} `;
    pathData += `A ${rInner},${rInner} 0 ${largeArcFlag},0 ${xInnerStart},${yInnerStart} `;
    pathData += `Z`;

    return pathData;
}

export default initWheel;